angular.module('surfsightApp').config([
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider',
  function ($stateProvider, $urlRouterProvider, $locationProvider) {
    $urlRouterProvider.otherwise('/login')
    $locationProvider.hashPrefix('')
    $stateProvider
      .state('home', {
        url: '',
        abstract: true,
        views: {
          '@': {
            templateUrl: './templates/main.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        },
        onEnter: homeRouteOnEnter
      })
      .state('home.login', {
        url: '/login',
        views: {
          'content@home': {
            templateUrl: './templates/login.view.html?t=' + window.webpackHash,
            controller: 'LoginCtrl as lc'
          }
        }
      })
      .state('home.common', {
        url: '/home',
        views: {
          'content@home': {
            templateUrl: './templates/common.view.html?t=' + window.webpackHash,
            controller: 'homeCtrl as lc'
          }
        }
      })
      .state('home.common.reseller-sso', {
        url: '/reseller-sso/:organizationId/:jwtToken',
        params: {
          organizationId: null,
          jwtToken: null
        }
      })
      .state('home.common.edge', {
        url: '',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.common.videos.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.edge.list', {
        url: '/list',
        views: {
          'broadcastVideos@home.common.edge': {
            templateUrl:
              './templates/cameras.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('logout', {
        url: '/logout',
        views: {
          '@': {
            template: '<span ng-init="logout=\'logout\'">Logout</span>',
            controller: 'LogoutCtrl'
          }
        }
      })
      .state('home.resetpassword', {
        url: '/resetpassword',
        abstract: true
      })
      .state('home.resetpassword.reset', {
        url: '/:token',
        views: {
          'content@home': {
            templateUrl:
              './templates/home.resetpassword.view.html?t=' +
              window.webpackHash,
            controller: 'ResetPasswordCtrl'
          }
        }
      })
      .state('home.edge', {
        url: 'edge',
        abstract: true
      })
      .state('home.edge.list', {
        url: 'list',
        views: {
          'content@home': {
            templateUrl:
              './templates/cameras.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.settings', {
        url: '/settings',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/settings.list.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.maps', {
        url: '',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/map.common.view.html?t=' + window.webpackHash,
            controller: 'mapCtrl as mc'
          }
        }
      })
      .state('home.common.maps.view', {
        url: '/maps',
        views: {
          'mapContent@home.common.maps': {
            templateUrl:
              './templates/maps.list.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.maps.geofence', {
        url: '/geofence/:edge_id',
        params: {
          edge_id: null
        },
        views: {
          'mapContent@home.common.maps': {
            templateUrl:
              './templates/edge.geofence.settings.view.html?t=' +
              window.webpackHash,
            controller: 'geofenceCtrl as gc'
          }
        }
      })
      .state('home.common.maps.edgeTrips', {
        url: '/trips/:edge_id',
        params: {
          edge_id: null
        },
        views: {
          'mapContent@home.common.maps': {
            templateUrl:
              './templates/edge.trips.view.html?t=' + window.webpackHash,
            controller: ''
          }
        }
      })
      .state('home.common.recordings', {
        url: '/recordings',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.recordings.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.recordings.timeline', {
        url: '/timeline/:imei',
        params: {
          imei: null
        },
        views: {
          'timeline@home.common.recordings': {
            templateUrl:
              './templates/edge.recordings.timeline.view.html?t=' +
              window.webpackHash,
            controller: 'EdgeRecordingsTimelineController'
          }
        }
      })
      .state('home.common.recordings.list', {
        url: '/list/:imei',
        cache: false,
        params: {
          edge_id: null
          // refresh: { inherit: true }
        },

        views: {
          'header@home.common': {
            templateUrl:
              './templates/recordings.list.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.events', {
        url: '/events',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/events.list.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.reports', {
        url: '/reports',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/reports.list.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.events.history', {
        url: '/list/:imei',
        params: {
          imei: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.event.history.view.html?t=' +
              window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.reports.edge', {
        url: '/edge/:edge_id',
        params: {
          edge_id: null,
          eventSearch: null,
          reportType: null,
          eventType: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.report.history.view.html?t=' +
              window.webpackHash,
            controller: 'reportController as rc'
          }
        }
      })
      .state('home.common.reports.edgegroup', {
        url: '/group/:edge_group_id',
        params: {
          edge_group_id: null,
          eventSearch: null,
          reportType: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.report.history.view.html?t=' +
              window.webpackHash,
            controller: 'reportController as rc'
          }
        }
      })
      .state('home.common.reports.edgereportDashboard', {
        url: '/edgedashboard/:edge_id/:reportType',
        params: {
          edge_id: null,
          eventSearch: null,
          reportType: null,
          eventType: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.report.dashboard.history.view.html?t=' +
              window.webpackHash,
            controller: 'reportController as rc'
          }
        }
      })
      .state('home.common.reports.edgegroupreportDashboard', {
        url: '/edgegroupdashboard/:edge_group_id/:reportType',
        params: {
          edge_group_id: null,
          eventSearch: null,
          reportType: null,
          eventType: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.report.dashboard.history.view.html?t=' +
              window.webpackHash,
            controller: 'reportController as rc'
          }
        }
      })
      .state('home.common.events.dashboard', {
        url: '/dashboard/:edge_id',
        params: {
          edge_id: null,
          eventSearch: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/edge.events.dashboard.view.html?t=' +
              window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.healthReports', {
        url: '/health-reports/:healthReportType',
        params: {
          healthReportType: null
        },
        views: {
          'header@home.common': {
            templateUrl:
              './templates/health-reports/health-reports.view.html?t=' +
              window.webpackHash,
            controller: 'healthReportsController as hc'
          }
        }
      })
      .state('home.common.settings.users', {
        url: '/users',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/manage.organizations.users.view.html?t=' +
              window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.settings.familiarDriver', {
        url: '/familiar-driver',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/familiar.driver.view.html?t=' + window.webpackHash,
            controller: 'FamiliarDriverController'
          }
        }
      })
      .state('home.common.settings.partners', {
        url: '',
        views: {
          'header@home.common': {
            templateUrl:
              './templates/partner.view.html?t=' + window.webpackHash,
            controller: 'paternaerCtrl as ec'
          }
        }
      })
      .state('home.common.settings.partners.devices', {
        url: '/devices',
        views: {
          'partnerData@home.common.settings.partners': {
            templateUrl:
              './templates/partner.devices.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.settings.partners.organizations', {
        url: '/organizations',
        views: {
          'partnerData@home.common.settings.partners': {
            templateUrl:
              './templates/partner.organizations.view.html?t=' +
              window.webpackHash,
            controller: function () {}
          }
        }
      })
      .state('home.common.settings.partners.users', {
        url: '/users',
        views: {
          'partnerData@home.common.settings.partners': {
            templateUrl:
              './templates/partner.users.view.html?t=' + window.webpackHash,
            controller: function () {}
          }
        }
      })
  }
])

homeRouteOnEnter.$inject = [
  'userFactory',
  '$location',
  '$stateParams',
  '$localStorage',
  'jwtHelper',
  '$rootScope',
  '$injector',
  'edgeGroupFactoryV2'
]

function homeRouteOnEnter (
  userFactory,
  $location,
  $stateParams,
  $localStorage,
  jwtHelper,
  $rootScope,
  $injector,
  edgeGroupFactoryV2
) {
  if (!APP_V2_SUPPORT) {
    return true
  }

  return new Promise(async (resolve, reject) => {
    try {
      const currentUrl = $location.url()
      if (currentUrl.startsWith('/home/reseller-sso')) {
        await handleResellerSsoLogin(
          $stateParams,
          currentUrl,
          $localStorage,
          jwtHelper,
          $rootScope,
          userFactory,
          $injector,
          edgeGroupFactoryV2
        )
        resolve()
      } else {
        await userFactory.runAuthGuard()
        resolve()
      }
    } catch (e) {
      resolve()
    }
  })
}

async function handleResellerSsoLogin (
  $stateParams,
  currentUrl,
  $localStorage,
  jwtHelper,
  $rootScope,
  userFactory,
  $injector,
  edgeGroupFactoryV2
) {
  let jwtToken = $stateParams.jwtToken
  if (!jwtToken) {
    jwtToken = currentUrl.split('/')[4]
  }
  delete $localStorage.userToken
  delete $localStorage.userDetails
  delete $localStorage.userOrganization
  delete $localStorage.selectedOrganization
  delete $localStorage.currentUserOrganization
  delete $localStorage.userMediaAccessToken
  delete $localStorage.isResellerSso
  delete $localStorage.timeFormat
  delete $localStorage.measurementUnits
  delete $localStorage.userOrganization

  if (window.heap) {
    window.heap.resetIdentity()
  }
  const edgeFactory = $injector.get('edgeFactory')
  const edgeFactoryV2 = $injector.get('edgeFactoryV2')
  const edgeGroupFactory = $injector.get('edgeGroupFactory')
  const broadcastViewFactory = $injector.get('broadcastViewFactory')
  edgeFactory.list.splice(0, edgeFactory.list.length)
  edgeFactoryV2.clear()
  edgeGroupFactory.list.splice(0, edgeGroupFactory.list.length)
  edgeGroupFactoryV2.clear()
  broadcastViewFactory.list.splice(0, broadcastViewFactory.list.length)

  const organizationId = parseInt($stateParams.organizationId)
    ? $stateParams.organizationId
    : parseInt(currentUrl.split('/')[3])

  const resellerDetails = jwtHelper.decodeToken(jwtToken)
  resellerDetails.permission_role = 'administrator'
  resellerDetails.organizationId = organizationId

  $localStorage.isResellerSso = true
  $localStorage.resellerSsoExpireTime = new Date().getTime() + 30 * 60 * 1000

  $localStorage.userDetails = resellerDetails
  $localStorage.userToken = jwtToken
  $localStorage.currentUserOrganization = { id: organizationId }
  $rootScope.currentUserOrganization = { id: organizationId }

  await userFactory.runAuthGuard()
}
